import { render, staticRenderFns } from "./AddInterveneRecord.vue?vue&type=template&id=64d99636&scoped=true"
import script from "./AddInterveneRecord.vue?vue&type=script&lang=js"
export * from "./AddInterveneRecord.vue?vue&type=script&lang=js"
import style0 from "./AddInterveneRecord.vue?vue&type=style&index=0&id=64d99636&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d99636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d99636')) {
      api.createRecord('64d99636', component.options)
    } else {
      api.reload('64d99636', component.options)
    }
    module.hot.accept("./AddInterveneRecord.vue?vue&type=template&id=64d99636&scoped=true", function () {
      api.rerender('64d99636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/AddInterveneRecord.vue"
export default component.exports